import { CSSProperties, FC, ReactNode } from 'react';
import { Typography } from 'antd';
import { TitleProps } from 'antd/es/typography/Title';

type FleetTitleProps = {
	children: ReactNode;
	level?: TitleProps['level'];
	style?: CSSProperties;
	marginBottom?: number;
};

const FleetTitle: FC<FleetTitleProps> = ({
	level,
	children,
	style,
	marginBottom,
}) => {
	if (level === 1) {
		return (
			<Typography.Title
				level={level}
				style={{
					fontSize: 24,
					fontWeight: 600,
					lineHeight: '28px',
					padding: '10px 20px',
					background: '#FFF8DD',
					color: '#2F2F2F',
					borderLeft: '4px solid #FFD700',
					margin: 0,
					marginBottom: marginBottom ?? 20,
					...style,
				}}
			>
				{children}
			</Typography.Title>
		);
	}
	if (level === 3) {
		return (
			<Typography.Title
				level={level}
				style={{
					fontSize: 20,
					fontWeight: 600,
					lineHeight: '24px',
					padding: '10px 20px',
					background: '#E8F1FF',
					color: '#2F2F2F',
					margin: 0,
					marginBottom: marginBottom ?? 20,
					...style,
				}}
			>
				{children}
			</Typography.Title>
		);
	}
	if (level === 4) {
		return (
			<Typography.Title
				level={level}
				style={{
					fontSize: 18,
					fontWeight: 600,
					lineHeight: '22px',
					padding: '10px 20px',
					background: '#efefef',
					color: '#2F2F2F',
					margin: 0,
					marginBottom: marginBottom ?? 20,
					...style,
				}}
			>
				{children}
			</Typography.Title>
		);
	}
	return (
		<Typography.Title
			level={level}
			style={{
				fontSize: 20,
				fontWeight: 600,
				lineHeight: '24px',
				padding: '10px 20px',
				background: '#FFF8DD',
				color: '#2F2F2F',
				margin: 0,
				marginBottom: marginBottom ?? 20,
				...style,
			}}
		>
			{children}
		</Typography.Title>
	);
};

export default FleetTitle;
